import { ReportingState } from '../../model/reporting/reportingState';
import {
  CLEAR_REPORTING,
  FETCH_REPORTING_SYSTEM_ALERTS_SUCCESS,
} from '../constants';
import { initialState } from '../system/SystemState';
import { ReportingActionTypes } from '../types/reportingActionTypes';

export default function reportingReducer(
  state = initialState.reporting,
  action: ReportingActionTypes
): ReportingState {
  switch (action.type) {
    case FETCH_REPORTING_SYSTEM_ALERTS_SUCCESS:
      return {
        ...state,
        latestSystemAlerts: action.payload,
      };

    case CLEAR_REPORTING:
      return {
        latestSystemAlerts: [],
      };

    default:
      return state;
  }
}
